const C = require("../constants");

const showQuestionDialog = (data) => {
    return {
        type: C.SHOW_QUESTION_DIALOG,
        data
    }
};

export {showQuestionDialog};


// WEBPACK FOOTER //
// ./src/actions/QuestionDialogAction.js